import { ApiAddress } from "../apis"
import request from "../request"

export interface CaseModal {
  id: number
  number: number
  name: string
}

export function getProjectCases(params): Promise<CaseModal[]> {
  return request.get(ApiAddress.CASES, {params})
}

export function createProjectCase(body, params): Promise<CaseModal> {
  return request.post(ApiAddress.CASES, body, {params})
}
export function updateProjectCase(body, params): Promise<CaseModal> {
  return request.put(ApiAddress.CASE, body, {params})
}

export function deleteProjectCase(params): Promise<CaseModal> {
  return request.delete(ApiAddress.CASE, {params})
}